module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab3"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("经营情况信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d537cb9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssBlock/forEdit/ssTab3 copy.vue
// module id = 1771
// module chunks = 1